import { Box, Text } from "@wix/design-system";

interface SpeechErrorProps {
  message: string;
}

export function SpeechError({ message }: SpeechErrorProps) {
  return (
    <Box marginTop="10px" align="center">
      <Text size="small" skin="error">
        {message}
      </Text>
    </Box>
  );
}
